'use client';
import type { MouseEventHandler, ReactElement } from 'react';
import { motion } from 'framer-motion';
import { ColorType } from '@/theme/colors';
import { pxToRem } from '@/theme/spacing';
import { zIndex } from '@/theme/zIndex';
import { dataEl, type DataElScope } from '@/utils/dataEl';
import { Crippleloader } from '../Crippleloader';
import { CSS_POSITION_ABSOLUTE, CSS_POSITION_RELATIVE, NAVBAR_HEIGHT, } from './Cpagelayout.constants';
import { NavbarLogo } from './NavbarLogo';
import type { NavbarStyles } from './Cpagelayout.styles';
interface LoadingNavbarProps {
    dataElScope: DataElScope;
    isLandingPage: boolean;
    isMobile: boolean;
    navbarStyles: NavbarStyles;
    onLogoClick: MouseEventHandler<HTMLAnchorElement>;
}
interface LoadingNavbarBooleanInput {
    isLandingPage: boolean;
}
interface LoadingNavbarMobileInput {
    isMobile: boolean;
}
function getLoadingNavbarPosition({ isLandingPage, }: LoadingNavbarBooleanInput): 'absolute' | 'relative' {
    return isLandingPage ? CSS_POSITION_ABSOLUTE : CSS_POSITION_RELATIVE;
}
function getLoadingLogoSize({ isMobile, }: LoadingNavbarMobileInput): number {
    return isMobile ? 46 : 54;
}
function getLoadingControlSize({ isMobile, }: LoadingNavbarMobileInput): number {
    return isMobile ? 41 : 48;
}
function getLoadingRippleWidth({ isMobile, }: LoadingNavbarMobileInput): number {
    return isMobile ? 28 : 34;
}
export function LoadingNavbar({ dataElScope, isLandingPage, isMobile, navbarStyles, onLogoClick, }: LoadingNavbarProps): ReactElement {
    const controlSize = getLoadingControlSize({ isMobile });
    return (
      <motion.div data-el={dataEl(dataElScope, 'LoadingNavbar/Root')} initial={{ opacity: 0, y: -64 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -64 }} transition={{
            duration: 0.4,
            ease: [0.4, 0, 0.2, 1],
        }} style={{
            position: getLoadingNavbarPosition({ isLandingPage }),
            top: 0,
            left: 0,
            right: 0,
            height: pxToRem(NAVBAR_HEIGHT),
            zIndex: zIndex.navbar,
            pointerEvents: 'auto',
        }}>
        <motion.nav style={navbarStyles.base}>
          <div style={{ ...navbarStyles.left, opacity: 0 }}/>

          <div style={navbarStyles.center}>
            <NavbarLogo isMobile={isMobile} linkStyle={navbarStyles.logoLink} logoSize={getLoadingLogoSize({ isMobile })} motionStyle={navbarStyles.logoMotion} onClick={onLogoClick} useContainerFrame={true}/>
          </div>

          <div style={navbarStyles.right}>
            <div data-el={dataEl(dataElScope, 'LoadingNavbar/Status')} style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: controlSize,
            height: controlSize,
        }}>
              <Crippleloader dataElScope={dataElScope} width={getLoadingRippleWidth({ isMobile })} color={ColorType.White} pace={0.8}/>
            </div>
          </div>
        </motion.nav>
      </motion.div>
    );
}
